import { render } from "./ShukkaDetailReport.vue?vue&type=template&id=35c99af8&scoped=true"
import script from "./ShukkaDetailReport.vue?vue&type=script&lang=js"
export * from "./ShukkaDetailReport.vue?vue&type=script&lang=js"

import "./ShukkaDetailReport.vue?vue&type=style&index=0&id=35c99af8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\t.chida\\Desktop\\hybrid_inventory_baroque\\hybrid_inventory_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c99af8"]])

export default __exports__